import { action, computed, observable, makeObservable } from 'mobx';
import { FC } from 'react';

type TRightSidebarItem = {
  key: string;
  component: FC;
  componentProps: object | undefined;
};

export class RightSidebarStore {
  @observable data: TRightSidebarItem[] = [];

  constructor() {
    makeObservable(this);
  }

  @computed get lastItem(): TRightSidebarItem {
    return this.data[this.data.length - 1];
  }

  @action openRightSidebarItem(key: string, component: FC, componentProps?: any): void {
    if (this.data.find((item) => item.key === key)) {
      return;
    }

    this.data.push({ key, component, componentProps });
  }

  @action closeRightSidebarItem(key: string): void {
    this.data = this.data.filter((item) => item.key !== key);
  }

  @action reset(): void {
    this.data = [];
  }
}
